import { Fragment, useEffect } from 'react';
import { Navbar } from 'fileIndexing/otherComponents/Navbar';
import { NavigationMenu } from 'fileIndexing/otherComponents/NavigationMenu';

import { TagsTable } from '../components/TagsTable';

export function TagMainPage () {
    useEffect(() => {
        document.title = 'File Indexing - Tags';
    }, []);

    return (
        <Fragment>
            <Navbar />
            <NavigationMenu />
            <TagsTable />
        </Fragment>
    );
}